(function () {
    // save the section id from the script tag and find the section
    const sectionID = document.currentScript.dataset.id;
    const section = document.querySelector(`#${sectionID}`);

    // exit if section is not found
    if (!section) {
        console.warn(`Product section with ID ${sectionID} not found.`);
        return;
    }

    // get product data
    // note, the selling plan toggle swaps between separate products, so this is reassigned when the toggle changes
    let product = JSON.parse(section.querySelector(".productV1JSON").textContent);

    // keep the base product so display can fall back to it when a toggle has no product (e.g. a bundle with no base subscription product)
    const baseProduct = product;

    // get bundle products if this product is a bundle
    // bundles are added to the cart in place of the base product, swapping each to its own subscription variant when subscribed
    let bundleProducts = [];
    const bundleJSON = section.querySelector(".productV1BundleJSON");
    if (bundleJSON) {
        bundleProducts = JSON.parse(bundleJSON.textContent);
    }

    // note, the starting activeVariant is set in the section liquid file, when options are changed we fetch the new variant data from the server
    let activeVariant = JSON.parse(section.querySelector(".productV1VariantJSON").textContent);
    let quantity = 1;

    // during dev mode, set the active variant to the window so it can be accessed in the console
    if (Shopify.theme.role === "development") {
        window.product = product;
        window.activeVariant = activeVariant;
    }

    // collection titles for the klaviyo Viewed Product event, the product JSON drop does not include collections
    const productCollections = JSON.parse(section.querySelector(".productV1CollectionsJSON").textContent);

    // If the section has an announcement text override, store it (the element is only rendered when a block sets one).
    let announcementOverride = false;
    const announcementOverrideJSON = section.querySelector(".productV1AnnouncementOverride");
    if (announcementOverrideJSON) {
        announcementOverride = JSON.parse(announcementOverrideJSON.textContent);
    }

    /************
     Product Swiper
     ************/

    const productSwiper = new Swiper(section.querySelector(".productV1VisualSwiper"), {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: true,
        navigation: {
            nextEl: section.querySelector('.productV1VisualControlsBtn.next'),
            prevEl: section.querySelector('.productV1VisualControlsBtn.prev'),
        },
        pagination: {
            el: section.querySelector('.productV1VisualControlsPag'),
            clickable: true,
        },
        autoHeight: true,
        on: {
            slideChange: function () {
                if (!section.querySelector(".productV1VisualSwiperSlide")) {
                    return;
                }

                // pause all videos
                section.querySelectorAll(".productV1VisualSwiperSlide video").forEach(element => {
                    element.pause();
                });
            }
        }
    });

    // play video on slide play click
    section.querySelectorAll(".productV1VisualSwiperSlide").forEach(element => {
        element.addEventListener("click", function () {
            // get video
            const video = this.closest(".productV1VisualSwiperSlide").querySelector("video");

            if (!video) {
                return;
            }

            // remove play button if it hasn't already been removed
            this.querySelector(".productV1VisualSwiperSlidePlay")?.remove();

            // show controls
            video.controls = true;

            // play video
            video.play();
        });
    });

    // update active variant on input changes
    section.querySelectorAll("input, select").forEach(function (element) {
        element.addEventListener("change", function () {
            updateProduct();
        });
    })

    /**************
     Update Product
     ***************/

    async function updateProduct() {

        // find active variant
        activeVariant = await getActiveVariant();

        // check if variant wasn't found (null would be returned from the fetch)
        if (!activeVariant) {
            section.querySelector(".productV1ATC").disabled = true;
            section.querySelector(".productV1ATCText").textContent = "Not Available";
            return;
        }

        /**************
         Variant Image
         ***************/

        if (activeVariant.featured_image) {
            // change active slide
            productSwiper.slideTo(activeVariant.featured_image.position - 1);
        }

        /**************
         ATC Enable/Disable
         ***************/

        // check if the variant is in stock
        if (activeVariant.available) {
            section.querySelector(".productV1ATC").disabled = false;
            // restore the merchant's add to cart text from the setting so the richtext markup (e.g. strikethrough) survives
            section.querySelector(".productV1ATCText").innerHTML = section.querySelector(".productV1ATC").dataset.addToCartText;
        } else {
            section.querySelector(".productV1ATC").disabled = true;
            section.querySelector(".productV1ATCText").textContent = "Sold Out";
            section.querySelector(".productV1StickyATCValue").textContent = ""
        }

        /*************
         Update Sticky
         *********/
        const stickyAtc = section.querySelector(".productV1StickyATC") || false;

        if (activeVariant.available && stickyAtc) {
            // remove the 'sub' class when it's not needed (the case of an OTP variant).
            const stickyValue = section.querySelector(".productV1StickyATCValue");
            const sellingInput = section.querySelector(".productV1SellingLabelInput:checked");
            stickyAtc.classList.remove("sub");
            const stickyVariantId = parseInt(sellingInput?.dataset.variantId, 10);
            stickyAtc.dataset.variantId = stickyVariantId || activeVariant.id;
            stickyAtc.dataset.sellingPlan = "";
            stickyAtc.dataset.quantity = sellingInput?.dataset.quantity || "1";
            stickyValue.textContent = price(activeVariant.price, true).toString();
            if (isSubscription()) {
                // Quick add is looking for the 'sub' class in order to conditionally add the selling plan to the form data
                stickyAtc.classList.add("sub");
                stickyAtc.dataset.sellingPlan = sellingInput.dataset.plan;
                if (sellingInput.dataset.price) {
                    stickyValue.textContent = price(sellingInput.dataset.price, true).toString();
                }
            }
        }

        // update url with variant id so the selected options are maintained on refresh
        let url = new URL(window.location.href);
        url.searchParams.set("variant", activeVariant.id);
        window.history.replaceState({}, "", url);
    }

    // on load, update the product
    // this accomplishes loading the correct variant image and price on page load
    updateProduct();

    const stickyBar = section.querySelector(".productV1Sticky");
    const mainAtc = section.querySelector(".productV1ATC");
    if (stickyBar && mainAtc) {
        const syncStickyVisibility = function () {
            stickyBar.classList.toggle("is-visible", mainAtc.getBoundingClientRect().bottom <= 0);
        };

        window.addEventListener("scroll", syncStickyVisibility, {passive: true});
        window.addEventListener("resize", syncStickyVisibility);
        syncStickyVisibility();
    }

    /**************
     Product Quantity
     ***************/

    // minus
    section.querySelector(".productV1QuantityControlsBtn.minus")?.addEventListener("click", async function () {
        if (quantity === 1) {
            return;
        }
        quantity--;
        section.querySelector(".productV1QuantityControlsValue").textContent = quantity;
        await updateProduct();
    });

    // plus
    section.querySelector(".productV1QuantityControlsBtn.plus")?.addEventListener("click", async function () {
        quantity++;
        section.querySelector(".productV1QuantityControlsValue").textContent = quantity;
        await updateProduct();
    });

    // update product on input change
    section.querySelectorAll(".productV1OptionsItemValuesLabelInput").forEach(function (element) {
        element.addEventListener("change", async function () {
            await updateProduct();
        });
    });

    section.querySelectorAll(".productV1SellingLabelInput").forEach(function (element) {
        element.addEventListener("change", async function () {
            await updateProduct();
        });
    });

    /**
     * Returns the product for the checked selling plan toggle.
     * We add separate products for OTP and SUB
     * @returns {Object} The active product object
     */
    function getActiveProduct() {
        const sellingInput = section.querySelector(".productV1SellingLabelInput:checked");

        // fall back to the page product when there is no selling plan toggle
        if (!sellingInput) {
            return baseProduct;
        }

        // fall back to the base product when the toggle has no product (a bundle with no base subscription product still drives display off the base)
        const toggleProduct = JSON.parse(sellingInput.dataset.product || "null");
        if (!toggleProduct) {
            return baseProduct;
        }

        return toggleProduct;
    }

    /**
     * Checks whether the subscription selling plan toggle is selected.
     * @returns {boolean} True when the checked toggle is the subscription product
     */
    function isSubscription() {
        return section.querySelector(".productV1SellingLabelInput:checked")?.value === "sub";
    }

    /**
     * Fetches the active variant based on the selected options.
     * The selling plan toggle swaps between separate products, so the variant is resolved against the active product.
     * If there are more than 250 variants, it makes a request to the server to fetch the active variant since Shopify's storefront API has a limit of 250 variants per product.
     * @returns {Promise<Object>} The active variant object
     */
    async function getActiveVariant() {
        // resolve the product the selling plan toggle currently points at
        product = getActiveProduct();

        // Fetch variant when exceeding Shopify's 250 variant limit
        if (product.variants.length >= 250) {
            const optionIDs = [];
            section.querySelectorAll(".productV1OptionsItemValuesLabelInput:checked").forEach(element => {
                optionIDs.push(element.dataset.id);
            });
            const response = await fetch(`/products/${product.handle}?view=active-variant&option_values=${optionIDs.join(',')}`)
                .then(response => response.json());
            return response.active_variant;
        }

        // If there's only one variant, return it immediately
        if (product.variants.length === 1) {
            return product.variants[0];
        }

        // Gather selected values
        const options = [];
        section.querySelectorAll('.productV1OptionsItem').forEach(group => {
            options.push(group.querySelector('input:checked').value);
        });

        // Find matching variant and return it
        return product.variants.find(variant =>
            JSON.stringify(variant.options) === JSON.stringify(options)
        );
    }

    /**************
     Product ATC
     ***************/

    async function addToCart() {

        // add loading animation to both buttons
        section.querySelector(".productV1ATC").classList.add("loading");

        // keep activeVariant in sync with the checked plan (sub vs OTP product)
        await updateProduct();

        let formData = {items: []};

        if (bundleProducts.length > 0 && !section.classList.contains("productProtectRedesignV1")) {
            // bundle: add each bundle product in place of the base product
            const subscribed = isSubscription();
            bundleProducts.forEach(bundleProduct => {
                let item = {quantity: quantity, id: bundleProduct.otp_id};

                // swap to the bundle product's own subscription variant when subscribed and it has one
                if (subscribed && bundleProduct.sub_id) {
                    item.id = bundleProduct.sub_id;
                    item.selling_plan = parseInt(bundleProduct.plan);
                }

                formData.items.push(item);
            });
        } else {
            // single product
            const sellingInput = section.querySelector(".productV1SellingLabelInput:checked");
            const planQuantity = parseInt(sellingInput?.dataset.quantity, 10);
            const lineQuantity = Number.isFinite(planQuantity) && planQuantity > 0 ? planQuantity : quantity;
            let variantId = activeVariant.id;

            // Prefer the variant from the selected toggle's product (sub_product on Subscribe)
            if (sellingInput) {
                const explicitVariantId = parseInt(sellingInput.dataset.variantId, 10);
                if (explicitVariantId) {
                    variantId = explicitVariantId;
                } else {
                    try {
                        const toggleProduct = JSON.parse(sellingInput.dataset.product || "null");
                        if (toggleProduct && Array.isArray(toggleProduct.variants) && toggleProduct.variants.length === 1) {
                            variantId = toggleProduct.variants[0].id;
                        } else if (toggleProduct && activeVariant) {
                            const matched = (toggleProduct.variants || []).find(variant =>
                                JSON.stringify(variant.options) === JSON.stringify(activeVariant.options)
                            );
                            if (matched) {
                                variantId = matched.id;
                            } else if (toggleProduct.variants && toggleProduct.variants[0]) {
                                variantId = toggleProduct.variants[0].id;
                            }
                        }
                    } catch (e) {
                        // keep activeVariant.id
                    }
                }
            }

            formData.items.push({quantity: lineQuantity, id: variantId});

            // check for selling plan
            if (isSubscription()) {
                formData.items[0].selling_plan = parseInt(sellingInput.dataset.plan, 10);
            }
        }

        if (section.dataset.template) {
            attachTemplateProperty(formData, section);
        }

        // add product
        await addProduct(formData);

        // remove loading animation
        section.querySelector(".productV1ATC").classList.remove("loading");

        // open cart
        await openCart();
    }

    section.querySelector('.productV1ATC').addEventListener("click", addToCart);

    /**************
     Amazon Links
     ***************/

    // external "Shop on Amazon" links: fire the custom Amazon Click event plus an Add to Cart optimization signal
    section.querySelectorAll(".productV1LinksItem").forEach(function (element) {
        element.addEventListener("click", function () {
            // send an Add to Cart signal (variant id, matching their other pixels) so Amazon clicks optimize like a conversion
            const price = activeVariant ? activeVariant.price * quantity : 0;
            const productID = product.id;

            // gtag
            try {
                gtag("event", "click", {
                    "event_category": "website-amz-click",
                    "event_label": "prodpage-amz-click"
                });
                gtag("event", "add_to_cart", {
                    currency: Shopify.currency,
                    value: price,
                    items: [{item_id: productID}]
                });
                gtag('event', 'conversion', {
                    'send_to': 'AW-846224746/f8wLCO6pk-4cEOq6wZMD'
                });
            } catch (e) {
                console.error(`Failed to fire gtag for amazon click ${e}`)
            }

            // klaviyo
            try {
                klaviyo.push(["track", "Amazon Click"]);
                klaviyo.push(["track", "Added to Cart", {
                    ProductID: productID,
                    Value: price,
                    Currency: Shopify.currency
                }]);
            } catch (e) {
                console.error(`Failed to fire klaviyo for amazon click ${e}`)
            }

            // PostHog custom event
            try {
                posthog.capture("Amazon Click");
                posthog.capture("Add To Cart", {
                    product_id: productID,
                    value: price,
                    currency: Shopify.currency
                });
            } catch (e) {
                console.error(`Failed to fire posthog for amazon click ${e}`)
            }

            // facebook events
            try {
                fbq("track", "amz-click");
                fbq("track", "AddToCart", {
                    content_ids: [productID],
                    content_type: "product",
                    value: price,
                    currency: Shopify.currency
                });
            } catch (e) {
                console.error(`Failed to fire facebook for amazon click ${e}`)
            }

            // Intelligems: secondary goal for the Restore ABCD test
            try {
                window.igEvents = window.igEvents || [];
                window.igEvents.push({event: "Amazon Click"});
            } catch (e) {
                console.error(`Failed to fire intelligems for amazon click ${e}`)
            }

        });
    });


    // Scroll to reviews
    section.querySelectorAll('.scrollToReviews')?.forEach((element) => {
        element.addEventListener("click", function () {

            const reviewsTarget = document.querySelector(".reviewsTarget");
            if (!reviewsTarget) {
                return;
            }

            // smooth scroll the reviews into view, offset by 80px for the fixed header
            const top = reviewsTarget.getBoundingClientRect().top + window.scrollY - 80;
            window.scrollTo({top: top, behavior: "smooth"});
        })
    })

    /*************************
     Announcement Override
     *************************/
    if (announcementOverride) {
        document.querySelector("#announcementText").innerHTML = announcementOverride.override_text;
    }

    /*************************
     Klaviyo Viewed Product
     *************************/

    // the klaviyo library is held until marketing consent is granted, so the view can only be tracked once it exists
    (async () => {
        await doesHaveMarketingConsent();

        // poll for the async library, the push would throw if it fired before klaviyo.js finished loading
        while (typeof klaviyo === "undefined") {
            await new Promise(resolve => setTimeout(resolve, 200));
        }

        // build from baseProduct, the selling plan toggle can reassign product while we wait on consent
        try {
            klaviyo.push(["track", "Viewed Product", {
                ImageURL: `https:${baseProduct.featured_image}`,
                Price: price(baseProduct.price),
                Name: baseProduct.title,
                ProductID: baseProduct.id,
                Categories: productCollections,
                Value: (baseProduct.price / 100).toFixed(2),
                Brand: baseProduct.vendor,
                URL: `${window.location.origin}/products/${baseProduct.handle}`,
                CompareAtPrice: price(baseProduct.compare_at_price || 0)
            }]);
        } catch (e) {
            console.error(`Failed to fire klaviyo for viewed product ${e}`)
        }
    })();

}());
